let config = require('./config')
let utils = require('@common/utils')
let request = require('@common/request')
let iBorad = require('@common/iBorad')
require('@common/old.api')
let mask = require('../../modules/mask/index')

_qblog.setting({key: 20014, tcss: true});
_qblog.wsd.click("LOVEAPARTMENT.PV");

//AMS新集成
zHttp.baseUrl = "http://iyouxi3.vip.qq.com/ams3.0.php";
//活动地址 不带任何参数
var _pageUrl = location.protocol + '//' + location.host + location.pathname;
//main
let Page = qv.zero.extend(qv.zero.AbstractPage, {
  // 项目ID
  userJsonID: 300495,
  loadExtHandler: true,
  init: function () {
    Page.superclass.init.apply(this, arguments);
    if (!(navigator.userAgent.match(/Android|iPhone|iPad|iPod|webOS|BlackBerry|Windows Phone/i)) && !qbsdk.isQB()) {
      mask("QBrowser", '本活动为QQ浏览器专属活动', '请使用QQ浏览器参加')
    }
  },
  initEvent: function () {
    Page.superclass.initEvent.apply(this, arguments);
    $('body').on('click', 'a[href="#"]', function (e) {
      e.preventDefault();
    });
    qq.login.bind('login', function () {
      lottery.firstLogin();
      lottery.getVoted();
      $(".lucktime").show();
      $(".loginQQ").hide();
    });
    qq.login.bind('logout', function () {
      $(".lucktime").hide();
      $(".loginQQ").show();
    });
    if (qq.login.getUin()) {
      lottery.firstLogin();
      lottery.getVoted();
      $(".lucktime").show();
      $(".loginQQ").hide();
    }else{
      $(".lucktime").hide();
      $(".loginQQ").show();
    }

    $(".feed .feedBack").click(function () {
      _qblog.wsd.click("LOVEAPARTMENT.SUPPORT");
    });
    // lottery.getVideosInfo();
  },

})
window.page = new Page()



// WEBPACK FOOTER //
// ./pages/index/index.js